import useUserPreferences from "@/hooks/useUserPreferences"
import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import { useCurrency } from "../DesktopHeader"

const MobileProductOptions = (
    {demoProductDescription, name, product, check_in_wishlist, WishlistDel, addToWishlist, setPersonalizeModal} :
    {
        demoProductDescription: string,
        name?: string,
        product?:any,
        check_in_wishlist: boolean,
        WishlistDel: any,
        addToWishlist: any,
        setPersonalizeModal: any
    } 
) => {
    const {t} = useTranslation('product')
    const { locale } = useRouter()

    const preferences = useUserPreferences();
    const preferencesCurrency = useCurrency(preferences?.currencyCode ?? "ILS");

    // Use the price object from API with proper fallbacks
    const displayPrice = product?.front_price

  return (
    <div className="flex flex-col gap-1 px-4 pt-4" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
        <div
            className={`lg:mt-6 leading-relaxed text-base font-normal ${locale === 'ar' ? 'text-right' : 'text-left'}`}
            dangerouslySetInnerHTML={{
                __html: demoProductDescription.replace(
                new RegExp('{basmti}', 'g'),
                (name || (locale === 'ar' ? product?.replace_name?.ar : product?.replace_name?.en) || '')
                ),
        }}></div>
        <div className="sticky bg-white bottom-0 pb-1 flex flex-col gap-4">
            <div className="flex flex-row items-center justify-between">
                <div className="flex flex-row items-center justify-center gap-2">
                    <h2 className="text-primary-900 text-3xl lg:text-4xl font-bold">
                        <span>{displayPrice?.symbol}</span>
                        {displayPrice?.amount}
                    </h2>
                    {product?.has_sale && (
                        <h3 className={`old-price text-red ${locale === 'ar' ? 'mr-2' : 'ml-2'} line-through text-2xl`}>
                            <span>{product?.price?.symbol}</span>
                            {product?.price?.amount}
                        </h3>
                    )}
                </div>
                <div>
                    {check_in_wishlist && (
                        <a
                            href="#"
                            onClick={e => {
                            e.preventDefault()
                            WishlistDel(product.id)
                            }}
                            className="border border-primary rounded-lg mr-4 flex items-center justify-center p-3">
                            <svg
                            width="23"
                            height="24"
                            viewBox="0 0 23 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.1357 24C19.7657 23.999 19.3996 23.9247 19.0586 23.7813C18.7175 23.638 18.4083 23.4285 18.1487 23.165L11.9987 17.051L5.84866 23.169C5.45369 23.5697 4.94715 23.8422 4.39508 23.9508C3.843 24.0594 3.27101 23.9992 2.75366 23.778C2.23118 23.5678 1.7842 23.205 1.47112 22.7369C1.15803 22.2688 0.993376 21.7171 0.998658 21.154V5C0.998658 3.67392 1.52544 2.40215 2.46312 1.46447C3.40081 0.526784 4.67258 0 5.99866 0L17.9987 0C18.6553 0 19.3054 0.129329 19.9121 0.380602C20.5187 0.631876 21.0699 1.00017 21.5342 1.46447C21.9985 1.92876 22.3668 2.47996 22.618 3.08658C22.8693 3.69321 22.9987 4.34339 22.9987 5V21.154C23.0043 21.7167 22.8402 22.268 22.5278 22.7361C22.2155 23.2041 21.7694 23.5672 21.2477 23.778C20.8955 23.9253 20.5174 24.0008 20.1357 24Z"
                                fill="#00214D"
                            />
                            </svg>
                        </a>
                        )}
                        {!check_in_wishlist && (
                        <a
                            href="#"
                            onClick={e => {
                            e.preventDefault()
                            addToWishlist(product.id)
                            }}
                            className="border border-primary rounded-lg mr-4 flex items-center justify-center p-3">
                            <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clipPath="url(#clip0_919_2605)">
                                <path
                                d="M20.1371 24C19.7672 23.999 19.4011 23.9247 19.0601 23.7813C18.719 23.638 18.4097 23.4285 18.1501 23.165L12.0001 17.051L5.85012 23.169C5.45515 23.5697 4.94861 23.8422 4.39654 23.9508C3.84447 24.0594 3.27247 23.9992 2.75512 23.778C2.23264 23.5678 1.78567 23.205 1.47258 22.7369C1.15949 22.2688 0.994841 21.7171 1.00012 21.154V5C1.00012 3.67392 1.52691 2.40215 2.46459 1.46447C3.40227 0.526784 4.67404 0 6.00012 0L18.0001 0C18.6567 0 19.3069 0.129329 19.9135 0.380602C20.5202 0.631876 21.0714 1.00017 21.5357 1.46447C22 1.92876 22.3683 2.47996 22.6195 3.08658C22.8708 3.69321 23.0001 4.34339 23.0001 5V21.154C23.0057 21.7167 22.8417 22.268 22.5293 22.7361C22.217 23.2041 21.7709 23.5672 21.2491 23.778C20.8969 23.9253 20.5189 24.0008 20.1371 24ZM6.00012 2C5.20447 2 4.44141 2.31607 3.8788 2.87868C3.31619 3.44129 3.00012 4.20435 3.00012 5V21.154C2.99976 21.3206 3.04879 21.4836 3.14102 21.6224C3.23325 21.7612 3.36455 21.8695 3.51831 21.9337C3.67208 21.9979 3.84143 22.0151 4.00496 21.9831C4.1685 21.9512 4.31888 21.8714 4.43712 21.754L11.3001 14.933C11.4875 14.7468 11.7409 14.6422 12.0051 14.6422C12.2693 14.6422 12.5228 14.7468 12.7101 14.933L19.5651 21.752C19.6834 21.8694 19.8338 21.9492 19.9973 21.9811C20.1608 22.0131 20.3302 21.9959 20.4839 21.9317C20.6377 21.8675 20.769 21.7592 20.8612 21.6204C20.9535 21.4816 21.0025 21.3186 21.0021 21.152V5C21.0021 4.20435 20.6861 3.44129 20.1234 2.87868C19.5608 2.31607 18.7978 2 18.0021 2H6.00012Z"
                                fill="#00214D"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_919_2605">
                                <rect width="24" height="24" fill="white" />
                                </clipPath>
                            </defs>
                            </svg>
                        </a>
                        )}
                </div>
            </div>
            <button
            className="text-white font-medium text-base py-4 px-10 bg-primary block text-center rounded-lg w-full cursor-pointer"
            id='mobile-personalize-button'
            onClick={() => setPersonalizeModal()}>
                {t('personalizeButton')}
            </button>
        </div>
    </div>
  )
}

export default MobileProductOptions;